import { useEffect } from "react";
import { useModal } from "../context/ModalContext";
import DialogMessage from "./DialogMessage";
import { TypeDialogMessageEnum } from "../model/Enums/TypeDialogMessageEnum";

interface ModalProps {
    type?: "success" | "error" | "question" | TypeDialogMessageEnum;
    successMessage: string;
    onClose: () => void;
    text?: string;
}

export default function GlobalModal({
    type = "success",
    successMessage,
    onClose,
    text,
}: ModalProps) {
    const { isOpen, closeModal } = useModal();

    useEffect(() => {
        function handleEscKey(event: KeyboardEvent) {
            if (event.key === "Escape") {
                closeModal();
            }
        }

        if (isOpen) {
            document.body.style.overflow = "hidden";
            document.addEventListener("keydown", handleEscKey);
        } else {
            document.body.style.overflow = "auto";
            document.removeEventListener("keydown", handleEscKey);
        }

        return () => {
            document.body.style.overflow = "auto";
            document.removeEventListener("keydown", handleEscKey);
        };
    }, [isOpen, closeModal]);

    if (!isOpen) {
        return null;
    }

    const handleModalClose = () => {
        onClose();
        closeModal();
    };

    return (
        <DialogMessage
            type={type}
            show={Boolean(successMessage)}
            title={successMessage}
            text={text || ""}
            onClose={handleModalClose}
        />
    );
}
